import {useTypedSelector} from "../../../hook/useTypedSelector";
import {useEffect, useState} from "react";
import {useActions} from "../../../hook/useActions";

function EditGroup() {
    const {allGroups} = useTypedSelector((store) => store.curatorialGroup);
    const {allUsers} = useTypedSelector((store) => store.user);
    const [selectedGroup, setSelectedGroup] = useState<any>(null);
    const [search, setSearch] = useState("");
    const {GetGroups, GetAllUsersAsync, SetCurator, AddListener, RemoveListener} = useActions();

    useEffect(() => {
        GetGroups();
        GetAllUsersAsync();
    }, []);

    useEffect(() => {
        const gid = new URLSearchParams(window.location.search).get("id");
        if (allGroups && allUsers && gid) {
            let group = allGroups.find((g: any) => g.id == gid);
            if (group) {
                if (group.curatorId) {
                    const curator = allUsers.find((u: any) => u.id === group.curatorId);
                    group = {...group, curator: curator || null};
                } else {
                    group = {...group, curator: null};
                }
                group.listeners = [];
                group.listenersId.forEach((g: any) => {
                    const listener = allUsers.find((u: any) => u.id === g);
                    if (listener) {
                        group.listeners.push(listener);
                    }
                })
                setSelectedGroup(group);
            }
        }
    }, [allGroups, allUsers]);

    // Filter users by fullName starting with search value (case-insensitive)
    const filteredUsers = allUsers
        ? allUsers.filter((u: any) =>
            (selectedGroup && !selectedGroup.listeners.find((l: any) => l.id === u.id) && selectedGroup.curatorId !== u.id ) && (u.fullName.toLowerCase().startsWith(search.toLowerCase()) || u.userName === search)
        ).slice(0, 3)
        : [];

    if (!selectedGroup) {
        return <div>Loading...</div>;
    }

    function handleRemoveClick(userId: string) {
        RemoveListener(selectedGroup.id, userId);
    }

    function handleAddClick(userId: string) {
        AddListener(selectedGroup.id, userId);
    }

    function handleSetAsCuratorClick(userId: string) {
        SetCurator(selectedGroup.id, userId);
    }

    return <div>
        <div>Current curator:     {selectedGroup.curator ? selectedGroup.curator.userName + " " + selectedGroup.curator.fullName: "None"}</div>
        <br/>
        <div>Current listeners:</div>

        <table>
            <thead>
            <tr>
                <th style={{minWidth: "200px"}}>User Name</th>
                <th style={{minWidth: "200px"}}>Full Name</th>
                <th style={{minWidth: "200px"}}>Options</th>
            </tr>
            </thead>
            <tbody>
            {selectedGroup.listeners.map((user: any) => (
                <tr key={user.id}>
                    <td>{user.userName}</td>
                    <td>{user.fullName}</td>
                    <td>
                        <button onClick={() => handleRemoveClick(user.id)}>Remove</button>
                    </td>
                </tr>
            ))}
            </tbody>
        </table>

        <br/>
        <br/>
        <br/>

        <input
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Search users by full name"
        />
        <table>
            <thead>
            <tr>
                <th style={{minWidth: "200px"}}>User Name</th>
                <th style={{minWidth: "200px"}}>Full Name</th>
                <th style={{minWidth: "50px"}}>Options</th>
            </tr>
            </thead>
            <tbody>
            {filteredUsers.map((user: any) => (
                <tr key={user.id}>
                    <td>{user.userName}</td>
                    <td>{user.fullName}</td>
                    <td>
                        <button onClick={() => handleAddClick(user.id)}>Add</button>
                        <button onClick={() => handleSetAsCuratorClick(user.id)}>Set as Curator</button>
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    </div>;
}

export default EditGroup;